import React from "react";
//import logo from "../../images/logo.png";

const SubscriptionModal = ({
  isOpen,
  handleSubscribeCard,
  handleSubscribeCancel,
  children,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed z-50 inset-0 overflow-y-auto">
      {/* Black Background Overlay */}
      <div className="absolute inset-0 bg-black opacity-75"></div>

      {/* Modal Content */}
      <div className="flex items-center w-full justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>
        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>
        <div className="fixed z-50 w-full inset-0 overflow-y-auto flex items-center justify-center">
          <div className="bg-white rounded-lg w-full shadow-xl max-w-lg mx-auto sm:my-8 p-6">
            {/* Logo */}
            <div className="flex justify-center  items-center mb-4">
              <img src={"/qushi_logo.png"} alt="Logo" className="h-16 w-auto" />
            </div>
            <h2 className="text-lg font-bold text-primaryColor mb-4">
              Subscribe
            </h2>
            {children}
            <div className="flex items-center justify-between mt-6">
              <button
                className="bg-primaryColor hover:bg-primaryColor text-white font-bold py-2 px-4 rounded mb-2 focus:outline-none focus:shadow-outline"
                onClick={handleSubscribeCard}
              >
                Subscribe
              </button>
              <button
                className="bg-gray-200 mb-2 hover:bg-gray-300 text-gray-800 font-medium py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                onClick={handleSubscribeCancel}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionModal;
